export default __webpack_public_path__ + "static/media/glrc-course.building-the-plate.b50fd85f.png";